import { useState, useEffect, useRef } from 'react';

// Scroll spy — tracks the active section and the header's scrolled state.
export const useScrollSpy = (sectionIds) => {
  const [activeSection, setActiveSection] = useState(sectionIds[0]);
  const [scrolled, setScrolled] = useState(false);

  // Keep the latest ids in a ref so the scroll listener is attached only once.
  const idsRef = useRef(sectionIds);
  idsRef.current = sectionIds;

  useEffect(() => {
    const handleScroll = () => {
      const ids = idsRef.current;
      setScrolled(window.scrollY > 24);
      for (let i = ids.length - 1; i >= 0; i--) {
        const el = document.getElementById(ids[i]);
        if (el && el.getBoundingClientRect().top <= 140) {
          setActiveSection(ids[i]);
          break;
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { activeSection, scrolled };
};
